import { render } from "./PaginationArrowRightDisabled.vue?vue&type=template&id=e5831412"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/PaginationArrowRightDisabled.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e5831412"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e5831412', __exports__)) {
    api.reload('e5831412', __exports__)
  }
  
  module.hot.accept("./PaginationArrowRightDisabled.vue?vue&type=template&id=e5831412", () => {
    api.rerender('e5831412', render)
  })

}


export default __exports__